/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ region: NonNullable<unknown> }} Onboarding_Pain_Region_RemoveInputs */

const en_us2_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.region}`)
};

const pt_br2_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tirar ${i?.region}`)
};

const es_419_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quitar ${i?.region}`)
};

const pt_pt2_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirar ${i?.region}`)
};

const fr_fr2_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.region}`)
};

const de_de2_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region} entfernen`)
};

const it_it2_onboarding_pain_region_remove = /** @type {(inputs: Onboarding_Pain_Region_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovi ${i?.region}`)
};

/**
* | output |
* | --- |
* | "Remove {region}" |
*
* @param {Onboarding_Pain_Region_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_pain_region_remove = /** @type {((inputs: Onboarding_Pain_Region_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pain_Region_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_pain_region_remove(inputs)
	if (locale === "es-419") return es_419_onboarding_pain_region_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_pain_region_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_pain_region_remove(inputs)
	if (locale === "de-DE") return de_de2_onboarding_pain_region_remove(inputs)
	if (locale === "it-IT") return it_it2_onboarding_pain_region_remove(inputs)
	return en_us2_onboarding_pain_region_remove(inputs)
});
export { onboarding_pain_region_remove as "onboarding.pain_region_remove" }